/* CINKELIS dynamic shipping/delivery info — runtime.

   Loaded by snippets/shipping-info.liquid via:
     {{ 'shipping-info.js' | asset_url | script_tag }}

   Owns:
     1. Date math — picks "Pristatysime today / tomorrow / YYYY.MM.DD"
        based on visitor local time, weekend/holiday rules (LT public
        holidays + DPD next-workday cutoff at 14:00).
     2. Tooltip behaviour — tap-to-toggle on mobile / keyboard, plus
        viewport-aware placement that flips the tooltip below the icon
        when there isn't enough room on the icon's left.

   Pure JS — no Liquid interpolation. Self-contained IIFE; bails out
   silently if the panel isn't on the page or has already been
   initialised, so it's safe to load on any template even though it's
   only useful on PDPs that include the snippet. */

(function () {
  'use strict';

  var root = document.getElementById('cnk-shipping');
  if (!root || root.dataset.cnkInit === '1') return;
  // Member panel is fully server-rendered — nothing for the JS to update.
  if (root.classList.contains('cnk-shipping--plus')) return;
  root.dataset.cnkInit = '1';

  // ----- Date helpers --------------------------------------------------
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function fmtLT(d) { return d.getFullYear() + '.' + pad(d.getMonth() + 1) + '.' + pad(d.getDate()); }

  // Gauss / Anonymous Gregorian computus for Easter Sunday.
  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31); // 3 or 4
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }
  function addDays(d, n) {
    var r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    r.setDate(r.getDate() + n);
    return r;
  }
  function firstSundayOfMonth(year, monthIdx) {
    var d = new Date(year, monthIdx, 1);
    while (d.getDay() !== 0) d.setDate(d.getDate() + 1);
    return d;
  }

  // Lithuanian public (non-working) holidays for a given year.
  function buildHolidays(year) {
    var easter = easterSunday(year);
    var set = {};
    var dates = [
      new Date(year, 0, 1),     // Naujieji metai
      new Date(year, 1, 16),    // Lietuvos valstybės atkūrimo diena
      new Date(year, 2, 11),    // Lietuvos nepriklausomybės atkūrimo diena
      easter,                   // Velykos
      addDays(easter, 1),       // Antroji Velykų diena
      new Date(year, 4, 1),     // Tarptautinė darbo diena
      firstSundayOfMonth(year, 4), // Motinos diena (1-asis gegužės sekmadienis)
      firstSundayOfMonth(year, 5), // Tėvo diena    (1-asis birželio sekmadienis)
      new Date(year, 5, 24),    // Joninės / Rasos
      new Date(year, 6, 6),     // Valstybės diena
      new Date(year, 7, 15),    // Žolinė
      new Date(year, 10, 1),    // Visų šventųjų diena
      new Date(year, 10, 2),    // Mirusiųjų atminimo (Vėlinės)
      new Date(year, 11, 24),   // Kūčios
      new Date(year, 11, 25),   // Šv. Kalėdos
      new Date(year, 11, 26)    // Antroji Kalėdų diena
    ];
    for (var i = 0; i < dates.length; i++) set[ymd(dates[i])] = true;
    return set;
  }

  var holidayCache = {};
  function isHoliday(d) {
    var y = d.getFullYear();
    if (!holidayCache[y]) holidayCache[y] = buildHolidays(y);
    return !!holidayCache[y][ymd(d)];
  }
  function isWorkday(d) {
    var dow = d.getDay(); // 0 Sun .. 6 Sat
    if (dow === 0 || dow === 6) return false;
    return !isHoliday(d);
  }
  function nextWorkday(d) {
    var r = addDays(d, 1);
    while (!isWorkday(r)) r = addDays(r, 1);
    return r;
  }

  // ----- Compute message ----------------------------------------------
  var now = new Date();
  var todayIsWorkday = isWorkday(now);
  var before14 = now.getHours() < 14;

  var titleEl = root.querySelector('[data-cnk-title]');
  var subEl   = root.querySelector('[data-cnk-sub]');

  // Pick the friendliest LT label for `d` relative to `now`:
  //   exactly today    → "šiandien"
  //   exactly tomorrow → "rytoj"
  //   anything else    → explicit YYYY.MM.DD
  //
  // Day-after-tomorrow ("poryt") deliberately falls through to the date
  // format per client request: the goal is "Pristatysime rytoj" or
  // "Pristatysime 2026.xx.xx" and nothing in between, so shoppers see
  // an unambiguous calendar day rather than a vague Lithuanian word
  // they might miscount. Same rule applied uniformly across all three
  // branches (before-14, after-14, weekend) so the title (ship day)
  // and the tooltip (delivery day) speak the same language.
  function relativeOrDate(d) {
    if (ymd(d) === ymd(now)) return 'šiandien';
    if (ymd(d) === ymd(addDays(now, 1))) return 'rytoj';
    return fmtLT(d);
  }

  var leftTitle, leftSub;

  // The green headline reads "Pristatysime [day]" — the carrier name
  // ("Su DPD") was dropped per client request; it's already implied by
  // the subtitle "Pasirinkus DPD paštomatą arba kurjerį". The tooltip
  // is body-only (no title) so there's no duplication.

  // ----- Long-weekend window ------------------------------------------
  // From Thursday 14:00 until Sunday 00:00, an order can't ship before
  // Friday and won't be delivered until Monday. Rather than show a
  // specific (far-looking) weekend date, the client wants a simple
  // "1-2 working days" message for this stretch. The window is purely
  // calendar-based (independent of the holiday calendar — the message
  // is fuzzy enough to stay correct):
  //   - Thursday from 14:00 onward
  //   - all of Friday
  //   - all of Saturday
  // It resets at Sunday 00:00 (one minute after Sat 23:59) back to the
  // normal dynamic logic below.
  var dow = now.getDay(); // 0 Sun .. 6 Sat
  var inLongWeekend =
    (dow === 4 && now.getHours() >= 14) || // Thu after 14:00
    dow === 5 ||                           // Fri
    dow === 6;                             // Sat

  if (inLongWeekend) {
    leftTitle = 'Pristatymas: 1-2 d.d.';
    leftSub   = 'Pasirinkus DPD paštomatą arba kurjerį';
  } else if (todayIsWorkday && before14) {
    // Order before 14:00 on a workday → ships today, delivered the
    // next workday (typically "rytoj"; explicit date when ordering on
    // a Friday before 14:00, since Saturday isn't a workday).
    var delivery0 = nextWorkday(now);
    leftTitle = 'Pristatysime ' + relativeOrDate(delivery0);
    leftSub   = 'Pasirinkus DPD paštomatą arba kurjerį';
  } else if (todayIsWorkday && !before14) {
    // Workday after 14:00 → ships the NEXT workday, delivered the
    // workday AFTER that. On Mon–Wed afternoons that's day-after-
    // tomorrow (rendered as a date, not "poryt"). On Thu/Fri
    // afternoons the weekend pushes delivery further out.
    var ship1     = nextWorkday(now);
    var delivery1 = nextWorkday(ship1);
    leftTitle = 'Pristatysime ' + relativeOrDate(delivery1);
    leftSub   = 'Pasirinkus DPD paštomatą arba kurjerį';
  } else {
    // Weekend / holiday → ships the next workday, delivered the
    // workday after.
    var ship2     = nextWorkday(now);
    var delivery2 = nextWorkday(ship2);
    leftTitle = 'Pristatysime ' + relativeOrDate(delivery2);
    leftSub   = 'Pasirinkus DPD paštomatą arba kurjerį';
  }

  if (titleEl) titleEl.textContent = leftTitle;
  if (subEl)   subEl.innerHTML     = leftSub;

  // ----- Tooltip toggling on tap (mobile / keyboard) ------------------
  var infoEl = root.querySelector('[data-cnk-info]');
  if (infoEl) {
    // ----- Viewport-aware placement -----------------------------------
    // The default layout flies the tooltip out to the LEFT of the icon
    // (280px wide + 12px gap). If the icon ends up close enough to the
    // viewport's left edge that the tooltip would overflow, fall back
    // to the bottom-anchored layout (same as the (max-width: 480px)
    // CSS fallback). Re-measured on resize and right before the
    // tooltip is shown — getBoundingClientRect() is cheap so this is
    // safe to call frequently.
    var FLIP_NEEDED_PX = 280 + 12 + 16; // tooltip width + gap + viewport safety
    function placeTooltip() {
      // Below 481px the @media query already forces the bottom layout
      // CSS-only — leave the class off so we don't fight it.
      if (window.innerWidth <= 480) {
        infoEl.classList.remove('cnk-shipping__info--flip');
        return;
      }
      var rect = infoEl.getBoundingClientRect();
      if (rect.left < FLIP_NEEDED_PX) {
        infoEl.classList.add('cnk-shipping__info--flip');
      } else {
        infoEl.classList.remove('cnk-shipping__info--flip');
      }
    }

    // Initial measurement (also covers SSR-rendered HTML on first
    // paint so a hover on the icon before resize ever fires gets the
    // right layout).
    placeTooltip();

    // Re-measure on viewport changes and right before the tooltip
    // becomes visible. mouseenter / focus catch the case where layout
    // shifted between init and hover (lazy-loaded images, theme
    // editor block insertions, etc.) without paying for a full
    // ResizeObserver.
    window.addEventListener('resize', placeTooltip, { passive: true });
    infoEl.addEventListener('mouseenter', placeTooltip);
    infoEl.addEventListener('focus', placeTooltip);

    infoEl.addEventListener('click', function (e) {
      e.stopPropagation();
      placeTooltip();
      infoEl.classList.toggle('is-open');
    });
    infoEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        placeTooltip();
        infoEl.classList.toggle('is-open');
      } else if (e.key === 'Escape') {
        infoEl.classList.remove('is-open');
      }
    });
    document.addEventListener('click', function (e) {
      if (!infoEl.contains(e.target)) infoEl.classList.remove('is-open');
    });
  }
})();
